import styled from 'styled-components';
import colors from '../../common/components/ui/colors';

export const TimeButton = styled.span`
  box-sizing: border-box;
  appearance: none;
  font-size: 1rem;
  padding: 13px 17px;
  border-radius: 2px;
  width: 100%;
  max-width: 270px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  background: white;
  border: 1px solid #CED5D8;
  box-shadow: 0 1px 5px 0 rgba(155,155,155,0.37);
  
  .time {
    font-family: 'Helvetica Neue', 'Helvetica', sans-serif;
    font-weight: bold;
    font-size: 24px;
    color: ${colors.BRAND_GREEN};
    line-height: 20px;
    display: inline-block;
    text-align: left;
    user-select: none;
   }
   
  .price {
    font-family: 'Helvetica Neue', 'Helvetica', sans-serif;
    font-weight: thin;
    font-size: 18px;
    color: #3E3E3E;
    line-height: 20px;
    display: inline-block;
    text-align: right;
    user-select: none;
   }
   
  .cannot-reserve {
    font-family: 'Helvetica Neue', 'Helvetica', sans-serif;
    font-weight: thin;
    font-size: 14px;
    color: #757575;
    line-height: 22px;
    text-align: center;
    display: inline-block;
  }
   
  &.disabled {
    background: ${colors.BLOCKED};
    .time {
      color: black;
    }
  }
  
  &:not(.disabled) {
    cursor: pointer;
    
    &:focus,
    &:hover {
      background: ${colors.ORANGE_HIGHLIGHT};
      .price,
      .time {
        color: white;
      }
    }
  }
  
  &.disable-hover {
    cursor: auto;
    
    &:focus,
    &:hover {
      background: white;
      
      .price {
        color: #3E3E3E;
      }
      
      .time {
        color: ${colors.BRAND_GREEN};
      }
    }
  }
`;

export const AddTimeButton = styled.a`
  box-sizing: border-box;
  appearance: none;
  background: transparent;
  font-size: 1rem;
  padding: 11px 15px;
  display: block;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
  .time {
    font-family: 'Helvetica Neue', 'Helvetica', sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: ${colors.BRAND_GREEN};
    line-height: 20px;
    display: inline-block;
    text-align: left;
   }
   
   .price {
    font-family: 'Helvetica Neue', 'Helvetica', sans-serif;
    font-weight: bold;
    font-size: 16px;
    color: ${colors.BRAND_GREEN};
    line-height: 20px;
    display: inline-block;
    text-align: right;
   }
`;



// WEBPACK FOOTER //
// ./src/modules/pros/components/TimeButton.js